<template>
	<div class="container container--narrow pdt-50 pdb-50">
			<div class="t-subtitle6 font-r  t-line-h-26 d-flex -align-items-center">
				{{ question.number }}. {{ question.contents.text }}
				<span class="t-color-mainBtn" v-if="question.essential">*</span>
			</div>
			<div class="mgt-24" v-if="question.contents && question.contents.image">
					<img :src="question.contents.image" alt="" class="b-radius4 survey-banner">
			</div>
			<div class="mgt-24">
				<div class="pdl-16 position-relative mdc-menu-anchor menu-container cursor-pointer header-toggle  d-flex justify-content-end align-items-center">
						<div class="t-body3 font-r t-color-bodyGrayA" v-on:click="shortedRatio" v-if="!sortingDefault">{{ $t("736")}}</div>
						<div class="t-body3 font-r t-color-bodyGrayA" v-on:click="shortedRatio" v-else>{{ $t("739")}}</div>
						<i class="material-icons mdc-icon-button t-color-bodyGrayA t-headline6 js--dropdown-toggle" v-on:click="shortedRatio" v-if="!sortingDefault">arrow_drop_up</i>
						<i class="material-icons mdc-icon-button t-color-bodyGrayA t-headline6 js--dropdown-toggle" v-on:click="shortedRatio" v-else>arrow_drop_down</i>
				</div>
		</div>
		<div class="mgt-16">
			<div v-for="choice in optionRatio" :key="choice.id">
				<div class="mgb-8 pdt-7 pdb-7 pdl-14 radio-wrapper b-radius4" v-if="!choice.comment" :class="{ selected: choice.selected }">
						<div class="d-flex justify-content-between align-items-center">
								<div class="mdc-form-field d-flex check_box_data mdc-checkbox--disabled">
									<div class="mdc-checkbox">
										<input type="checkbox" 
											class="mdc-checkbox__native-control" 
											:id="`check_${choice.id}`" 
											:checked="choice.selected"
										/>
										<div class="mdc-checkbox__background check-white">
											<svg class="mdc-checkbox__checkmark" viewBox="0 0 24 24">
												<path class="mdc-checkbox__checkmark-path" fill="none"
															d="M1.73,12.91 8.1,19.28 22.79,4.59" />
											</svg>
											<div class="mdc-checkbox__mixedmark "></div>
										</div>
										<div class="mdc-checkbox__ripple"></div>
									</div>
									<label :for="`check_${choice.id}`" :class="choice.selected ? 't-color-whiteHigh2' : 't-color-disabledTextfieldText'" class="t-body1 font-r t-line-h-20 pdl-6 checkbox_label">
										{{ choice.contents }}
									</label>
								</div>
								<div class="t-headline9 t-line-h-22 font-rn mgr-24 t-nowrap" :class="choice.selected ? 't-color-lectureRed':'t-color-iconInactive'">
									{{ choice.selectionRatio ? Math.round(choice.selectionRatio) : 0 }}%</div>
						</div>
						<div class="mgt-16 mgl-50 mgr-24 mgb-16" v-if="choice.image">
								<img :src="choice.image" alt="" class="b-radius4 survey-q-banner">
						</div>
						<div class="mgl-46 pdr-16 t-body6 t-color-whiteHigh2 font-r mgb-8" v-if="choice.selected && choice.feedback && eachViewFeedback">
								{{ choice.feedback }}
						</div>
				</div>
					<div class="mgb-8 pdt-7 pdb-7 pdl-14 radio-wrapper b-radius4 selected" v-else >
						<div class="d-flex justify-content-between align-items-center">
							<div class="mdc-form-field  d-flex w-full mdc-checkbox--disabled">
								<div class="mdc-checkbox">
										<input type="checkbox" 
										class="mdc-checkbox__native-control" 
										:checked="choice.comment" 
										/>
										<div class="mdc-checkbox__background check-white">
												<svg class="mdc-checkbox__checkmark" viewBox="0 0 24 24">
														<path class="mdc-checkbox__checkmark-path" fill="none"
																d="M1.73,12.91 8.1,19.28 22.79,4.59" />
												</svg>
												<div class="mdc-checkbox__mixedmark "></div>
										</div>
										<div class="mdc-checkbox__ripple"></div>
								</div>
								<label :for="`radioEtc`" class="t-body1 t-color-whiteHigh font-r t-line-h-20 pdl-6">
										{{ $t("754") }}
								</label>
							</div>
								<div class="t-headline9 t-color-lectureRed t-line-h-22 font-rn mgr-24 t-nowrap">
									{{ choice.selectionRatio ? Math.round(choice.selectionRatio) : 0 }}%</div>
						</div>
						<!-- <div class="mgt-16 mgl-50 mgr-24 mgb-16" v-if="choice.image">
								<img :src="choice.image" alt="" class="b-radius4">
						</div> -->
						<div class="mgl-46 pdr-16 t-body6 t-color-whiteHigh font-r mgb-8" v-if="choice.contents">
								{{ choice.contents }}
						</div>
				</div>
				</div>
				<div class="mgt-50"></div>
		</div>
	</div>
</template>
<script>
/**
 * 설문 - 다중응답 문항 피드백 컴포넌트(survey - choice multiple question feedback component)
 *
 * @author minkyoung.park@emcast.com
 */

// Components/Mixin/Extend/API define
export default {
	props: ["question", "eachViewFeedback"],
	data() {
		return {
			optionRatio: [],
			sortingDefault: false,
		};
	},

	mounted() {
		this.optionRatio = JSON.parse(JSON.stringify(this.question.choices));
	},

	methods: {
		shortedRatio(event) {
			this.sortingDefault = !this.sortingDefault;
			if (this.sortingDefault == true) {
				this.optionRatio = this.optionRatio.sort(function (a, b) {
					return b.selectionRatio - a.selectionRatio;
				});
			} else {
				this.optionRatio = JSON.parse(JSON.stringify(this.question.choices));
			}
		},
	},
};
</script>


<style scoped>
.flex-custom {
	display: flex;
	justify-content: space-between;
	align-items: center;
}
.checkbox_label{
	width:100%;
}
.check_box_data{
	width: 100%;
}
.radio-wrapper.selected .mdc-checkbox .mdc-checkbox__native-control[disabled]:checked~.mdc-checkbox__background, .radio-wrapper.selected .mdc-checkbox .mdc-checkbox__native-control[disabled]:indeterminate~.mdc-checkbox__background, .mdc-checkbox .mdc-checkbox__native-control[data-indeterminate=true][disabled]~.mdc-checkbox__background{
  background-color: var(--DocumentWhite) !important
}

.radio-wrapper.selected .mdc-checkbox .mdc-checkbox__native-control:disabled~.mdc-checkbox__background .mdc-checkbox__checkmark{
color:var(--QuizBlack);
}
</style>